/** Limits casual address scraping; client-side obfuscation is not secrecy. */
export function demoEmailUrl() {
  const recipient = atob("Y2hyb2hhbjk1QGdtYWlsLmNvbQ==");
  const subject = encodeURIComponent("Book a Calque demo");
  const body = encodeURIComponent(
    "Hi Rohan,\n\nI’d like to book a Calque demo.\n\nName:\nCompany:\nPreferred time:\n",
  );
  return `mailto:${recipient}?subject=${subject}&body=${body}`;
}
